export const formatUnixTime = value => {
  if (value == null || Number.isNaN(Number(value))) return ''
  let timestamp = Number(value)
  if (timestamp < 1e12) timestamp *= 1000
  const date = new Date(timestamp)
  const pad = num => String(num).padStart(2, '0')
  const datePart = [ date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate()) ].join('_')
  const timePart = [ pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds()) ].join(':')
  return `${datePart} ${timePart}`
}
